import client from '../config/AxiosConfig'

export const KudosList = async () => client.get('/kudos')

export const GetLatestKudos = async (page, limit) =>
  client.get(`/kudos/received/${page}/${limit}`)
